/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;
import CUSTOM_EVENT_TYPES from "analytics/util/CustomEventTypes";
import {
	OKEVENT,
	triggerOkEvent,
} from "shared/util/OkEventHelpers"

window.OkLike = {
	process(params, cb) {
		if (!params.target_userid) {
			return false;
		}

		let url = `/profile/${params.target_userid}`;
		let data = {};

		// check to make sure the callback is a function
		cb = typeof cb === "function" ? cb : function() {};

		if (params.score === 0) {
			data.cant_tell = "1";
			url = `${url}/unlike`;
		} else {
			url = `${url}/like`;
		}

		if (params.source && params.source !== "") {
			data.source = params.source;
		}

		return OkC.api(
			url,
			{
				api: 1,
				type: "POST",
				data,

				success: res => {
					return this.success(res, params, cb);
				},
			},
		);
	},

	success(response, params, cb) {
		if (response && response.status === 1) {
			let mutual = response.mutual_like;

			// fire the passed in callback
			if (typeof cb === "function") {
				cb(params.score, mutual, params.target_userid);
			}

			// trigger an okevent for the vote
			triggerOkEvent(OKEVENT.Vote, {
				score: params.score,
				liked: params.score > 3,
				mutual,
				tuid: params.target_userid,
			});

			return OkAnalytics.logUIEvent(
				OkAnalytics.eventNames.profileInteraction,
				{
					type: CUSTOM_EVENT_TYPES.user_content,
					data: ProfileActions.helpers.getEventData({
						interaction: params.score > 3 ? "like" : "unlike",
						userid: params.target_userid,
						matchPercentage: params.matchPercentage,
					}),
				},
			);
		}
	},
};



// WEBPACK FOOTER //
// ./src/legacy/oklike.js